import React from "react";
import FullScreenMessageCore from "./FullScreenMessageCore";
import { GiBreakingChain } from "react-icons/gi";
import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LOGIN } from "../../enums/UrlPaths";
import { getClinicShortName, isAdminOrEmployee } from "../../utils/Functions";
import usePrimaryColor from "../../hooks/usePrimaryColor";
import useUser from "../../hooks/useUser";
import { CRIMSON_RED } from "../../enums/Colors";
export default function ErrorFullScreenMessage({
  withoutWrapper,
  shouldCenter,
}) {
  const { t } = useTranslation();
  const { roles, currentClinic } = useUser();
  const color = usePrimaryColor();
  const navigate = useNavigate();
  function refreshPage() {
    window.location.reload();
  }

  function handleLogout() {
    const clinicShortName = currentClinic?.shortName;
    const isUserAdminOrEmployee = roles.adminOrEmployee;
    localStorage.clear();
    if (isUserAdminOrEmployee) {
      navigate(LOGIN + "/" + clinicShortName);
    } else {
      navigate(LOGIN);
    }
  }

  return (
    <FullScreenMessageCore
      withoutWrapper={withoutWrapper}
      shouldCenter={shouldCenter}
      title={t("LostConnectionTitle")}
      subtitle={t("LostConnectionSubtitle")}
      icon={<GiBreakingChain size={150} color={color} />}
      button={
        <Button
          variant="contained"
          sx={{
            bgcolor: "white",
            color: "black",
            ":hover": {
              boxShadow: "none",
              bgcolor: color,
              color: "white",
            },
          }}
          onClick={() => refreshPage()}
        >
          {t("TryReconnecting")}
        </Button>
      }
      secondButton={
        <Button
          variant="contained"
          color="error"
          sx={{
            ":hover": {
              boxShadow: "none",
              bgcolor: color,
              color: "white",
            },
          }}
          onClick={() => handleLogout()}
        >
          {t("LogOut")}
        </Button>
      }
    />
  );
}
